<template>
  <v-app lang="en">
    <router-view></router-view>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbarColor"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Loader :loading="wait"></Loader>
  </v-app>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import Loader from '@/components/helpers/Loader.vue';
import platformConfigApi from '@/modules/admin/api/platformConfigApi';

export default {
  name: 'App',
  components: {
    Loader,
  },
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      mode: '',
      snackbarText: '',
      timeout: 6000,
      x: null,
      y: 'bottom',
      wait: false,
    };
  },
  watch: {
    '$i18n.locale': function() {
      let globalTitle = process.env.VUE_APP_TITLE;
      document.title = this.$i18n.t(this.$route.meta.title) + ' · ' + globalTitle;
    },
  },
  created() {
    EventBus.$on('snackbar', this.snackbarChanged);
    EventBus.$on('waiting', this.waiting);
    this.loadPlatformConfig();
  },
  beforeDestroy() {
    EventBus.$off('snackbar', this.snackbarChanged);
    EventBus.$off('waiting', this.waiting);
  },
  methods: {
    snackbarChanged(params) {
      this.snackbarText = params.text;
      this.snackbarColor = params.color;
      this.snackbar = true;
    },
    waiting(value) {
      this.wait = value;
    },
    async loadPlatformConfig() {
      try {
        const response = await platformConfigApi.getConfig();
        this.$store.commit('setRagAnalyzerEnabled', response.data.ragAnalyzerEnabled);
      } catch (e) {
        // non-critical — keep default (false)
      }
    },
  },
};
</script>

<style>
a {
  text-decoration: none;
}

.required label::after {
  content: ' *';
}

.theme--dark.v-list {
  color: #ffffff;
}

.v-btn--active.no-active:not(:hover)::before {
  opacity: 0 !important;
}
.h-12 {
  height: 6rem !important;
  width: 10rem;
}
</style>
